import React from "react"
import { Education } from "../components/education"



export const EducationPage: React.FC = () =>{
  return (
    <div className="page">
      <Education/>
      </div>
    )
}